// Initializes a Stimulus application and dynamically loads controllers from the `./controllers` directory.
// Name your controller files [identifier]_controller.ts, where identifier corresponds to each controller’s data-controller identifier in your HTML.
//
// Example:
// If your controller file is named: `hello_controller.ts` then your HTML should include `data-controller="hello"`.

import { Application } from "@hotwired/stimulus";
import { definitionsFromContext } from "@hotwired/stimulus-webpack-helpers";

const application = Application.start();
const context = require.context("./controllers", true, /\.ts$/);
application.load(definitionsFromContext(context));

const componentControllers = require.context(
  "../../components/",
  true,
  /component_controller\.js$/,
);

componentControllers.keys().forEach((path: string) => {
  const mod = componentControllers(path);
  if (!mod.default) {
    return;
  }

  const identifier = path
    .match(/\.\/(.+)\/component_controller\.js$/)?.[1]
    .replaceAll("/", "--")
    .replaceAll("_", "-");

  if (identifier) {
    application.register(identifier, mod.default);
  }
});

application.registerActionOption(
  "open",
  ({ event, value }: { event: ToggleEvent; value: boolean }) => {
    if (event.type === "toggle") {
      return (event.target as HTMLDetailsElement)?.open === value;
    }

    return true;
  },
);
